import { BoardViewModel, BoardViewModelFactory, PitViewModelFactory, Theme } from "@mancala/core";
import { v4 } from "uuid";

// A plain board (no highlights) showing the given stone counts.
export function createBoardViewModel(stones: number[], theme: Theme): BoardViewModel {
    return BoardViewModelFactory.create(v4(), stones.map((stoneCount, index) => PitViewModelFactory.create({
        id: String(index), stoneCount, stoneColor: theme.stoneColor, pitColor: theme.pitColor,
    })));
}
